import { useState, useEffect, useRef } from "react";
import logo from "../../assets/icon.svg";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on click/touch outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside); // for mobile touch
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);


  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Join", href: "#join" },
    { name: "Contact", href: "#footer" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-sm" : ""
      }`}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-4">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-2 select-none">
          <img
            src={logo}
            alt="Interlink Logo"
            className="h-10 w-10 lg:h-12 lg:w-12"
          />
          <span className="font-semibold text-earth text-3xl lg:text-4xl">
            Inter<span className="text-accent">link</span>
          </span>
        </a>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-8 lg:text-lg">
          {navLinks.map((link) => (
            <li key={link.name}>
              <a
                href={link.href}
                className="hover:text-primary transition-colors duration-200 border-b-2 border-transparent hover:border-primary pb-1"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="text-white border bg-accent py-1 px-3 rounded-lg cursor-not-allowed opacity-80"
          title="Coming soon"
          disabled
        >
          Learning
        </button>
        
        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-3xl text-dark focus:outline-none"
          onClick={() => setOpen(!open)}
        >
          {open ? "✖" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <ul
          ref={menuRef}
          className="md:hidden bg-background px-6 py-4 flex flex-col gap-4 text-dark shadow-lg border-t border-accent/10 animate-fade-in"
        >
          {navLinks.map((link) => (
            <li key={link.name}>
              <a
                href={link.href}
                onClick={() => setOpen(false)}
                className="block py-2 text-lg hover:text-accent transition"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
